import { render, staticRenderFns } from "./WorkAutocomplete.vue?vue&type=template&id=49fc537b"
import script from "./WorkAutocomplete.vue?vue&type=script&lang=js"
export * from "./WorkAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./WorkAutocomplete.vue?vue&type=style&index=0&id=49fc537b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports